import { useQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import { queryKey } from '../../../../../constant/queryKey';
import { useGoodsSno } from '../../../../../hooks/useGoodsSno';

export const useGoodsModelInfo = () => {
  const sno = useGoodsSno();
  return useQuery({
    queryKey: queryKey.goodsModelInfo(sno),
    queryFn: () => goodsService.getGoodsModelInfo(sno),
  });
};
